import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import {
  Observable, catchError, map, of
} from 'rxjs';
import { environment } from '../../../environments/environment';

function hasUsableText(value: unknown): boolean {
  return typeof value !== 'string' || value.trim().length > 0;
}

export function removeEmptyTranslations(translations: TranslationObject): TranslationObject {
  const sanitizedTranslations: TranslationObject = {};

  for (const [key, value] of Object.entries(translations)) {
    if (value === null || value === undefined || !hasUsableText(value)) {
      continue;
    }

    sanitizedTranslations[key] =
      typeof value === 'object' && !Array.isArray(value) ? removeEmptyTranslations(value) : value;
  }

  return sanitizedTranslations;
}

@Injectable()
export class EmptyTranslationFallbackLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    const url = `/assets/i18n/${lang}.json?v=${environment.buildVersion}`;

    return this.http.get<TranslationObject>(url).pipe(
      map((translations) => removeEmptyTranslations(translations)),
      catchError(() => of({}))
    );
  }
}
